import { useState } from "react";
import Seo from "../components/Seo.tsx";
import CandleCard from "../components/candle/CandleCard.tsx";
import { useProducts } from "../lib/products-context.tsx";

const tabs = [
  { key: "all", label: "All" },
  { key: "new", label: "New" },
  { key: "bestseller", label: "Bestsellers" },
  { key: "gift", label: "Gifts" },
] as const;

type TabKey = (typeof tabs)[number]["key"];

export default function Collection() {
  const [active, setActive] = useState<TabKey>("all");
  const { products } = useProducts();
  const list = products.filter((p) => p.categories.includes(active));

  return (
    <div className="mx-auto max-w-6xl px-6 py-20 md:px-10 md:py-28">
      <Seo
        title="The Collection — Candles, Wax Melts & Sprays"
        description="Browse BeAdoré's full collection of hand-poured candles, sculptural waxes, aroma slates, and room sprays. All crafted from 100% vegan wax in small batches."
        path="/collection"
      />
      <header className="mb-14 flex flex-col items-end justify-between gap-8 md:flex-row">
        <div>
          <p className="eyebrow">The House Collection</p>
          <h1 className="mt-3 font-serif text-5xl text-[var(--color-emerald-deep)] md:text-6xl">
            Find your <em className="text-[var(--color-amber)]">scent</em>
          </h1>
          <p className="mt-4 max-w-md text-sm font-light text-[var(--color-stone)]">
            Hand-poured candles, sculptural waxes, and atelier accessories —
            each composed around a memory worth keeping.
          </p>
        </div>
        <div className="flex gap-1 rounded-full border border-[var(--color-rule)] bg-[var(--color-cream)] p-1">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActive(tab.key)}
              className={[
                "rounded-full px-5 py-2 text-[0.7rem] font-medium uppercase tracking-[0.12em] transition-all duration-300",
                active === tab.key
                  ? "bg-[var(--color-emerald-deep)] text-[var(--color-warm-white)]"
                  : "text-[var(--color-stone)] hover:text-[var(--color-emerald-deep)]",
              ].join(" ")}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </header>

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {list.map((p) => (
          <CandleCard key={p.id} product={p} />
        ))}
      </div>
    </div>
  );
}
